<template >
    <div id="main">
        <div v-if="!everythingLoaded()" style="margin: auto; height: 10rem" class="mdl-grid">
            <div class="mdl-spinner mdl-js-spinner is-active" style="height: 5rem; width: 5rem"></div>
        </div>
        <div class="page-content mdl-grid" v-else>
            <message-bar type="success" v-if="haveMenu() && haveOrdered()">
                <div class="mdl-grid">
                    <div class="mdl-cell mdl-cell--6-col-desktop mdl-cell--4-col-tablet mdl-cell--2-col-phone">
                        Den:
                    </div>
                    <div class="mdl-cell mdl-cell--6-col-desktop mdl-cell--4-col-tablet mdl-cell--2-col-phone">
                        {{todayHuman()}}
                    </div>

                    <div class="mdl-cell mdl-cell--6-col-desktop mdl-cell--4-col-tablet mdl-cell--2-col-phone">
                        Jídlo:
                    </div>
                    <div class="mdl-cell mdl-cell--6-col-desktop mdl-cell--4-col-tablet mdl-cell--2-col-phone">
                        <span v-if="food != null && food !== ''">
                            {{ food.orderedFood.foodCode }} - {{ food.orderedFood.name }}
                            <span v-if="food.foodOptions != null && food.foodOptions.length > 0">
                                (
                                <span v-for="(option, i) in food.foodOptions" :key="option.foodOptionId">
                                    {{option.foodOptionType.name}}<span v-if="i !== food.foodOptions.length - 1">,</span>
                                </span>
                                )
                            </span>
                        </span>
                        <span v-else>-</span>
                    </div>

                    <div class="mdl-cell mdl-cell--6-col-desktop mdl-cell--4-col-tablet mdl-cell--2-col-phone">
                        Polévka:
                    </div>
                    <div class="mdl-cell mdl-cell--6-col-desktop mdl-cell--4-col-tablet mdl-cell--2-col-phone">
                        <span v-if="soup != null && soup !== ''"> {{ soup.orderedSoup.name }}</span>
                        <span v-else>-</span>
                    </div>

                    <div class="mdl-cell mdl-cell--6-col-desktop mdl-cell--4-col-tablet mdl-cell--2-col-phone">
                        Celková cena:
                    </div>
                    <div class="mdl-cell mdl-cell--6-col-desktop mdl-cell--4-col-tablet mdl-cell--2-col-phone">
                        {{ orderPrice() }} Kč
                    </div>
                </div>
                Dobrou chuť. 👍 <br>
                <button class="mdl-button mdl-js-button mdl-button--raised mdl-color--accent" style="margin-top: 1rem; margin-bottom: 0.5rem; color: white" v-on:click="cancelOrder()">Zrušit objednávku</button>
            </message-bar>
            <message-bar type="info" v-if="!haveMenu()">
                <h6>Na dnešek ({{todayHuman()}}) zatím nemáme žádné menu 😠 Das ist los.</h6>
            </message-bar>
            <message-bar type="warning" v-else-if="!haveOrdered()">
                <h6>Dnes ({{todayHuman()}}) ještě nemáš vybraný oběd</h6>
            </message-bar>

            <menu-list class="mdl-cell mdl-cell--12-col" :food="getOrderedFood()" :soup="getOrderedSoup()"
                       :for-user="getMyUserId()" :day="today()" v-on:ordered-food="load()" :menus="menus"
                       :order-counts="orders"
                        v-on:snack="snack">
            </menu-list>
        </div>
        <snackbar :open-counter="snackbarCounter">
            {{ snackbarMessage }}
        </snackbar>
    </div>
</template>

<script>
    /* eslint-disable no-unused-vars */

    import MessageBar from "../components/widgets/MessageBar"
    import MenuList from "../components/MenuList"
    import axios from "axios"
    import config from "../config"
    import Snackbar from "../components/widgets/Snackbar";

    export default {
        name: "LunchOrder",
        components: {
            Snackbar,
            MessageBar,
            MenuList
        },
        data: function () {
            return {
                food: null,
                soup: null,
                menus: null,
                date: new Date().toISOString().substr(0, 10),
                orders: null,
                firstMostOrdered: 'xxx',
                secondMostOrdered: 'xxx',
                thirdMostOrdered: 'xxx',
                snackbarCounter: 0,
                snackbarMessage: ""
            };
        },
        methods: {
            haveMenu: function () {
                return this.menus != null && this.menus !== "" && this.menus.length > 0;
            },
            haveOrdered: function () {
                return (this.food != null && this.food !== "") || (this.soup != null && this.soup !== "");
            },
            load: function () {
                this.loadMenu();
                this.loadFood();
                this.loadSoup();
                this.loadOrders();
            },
            loadMenu: function () {
                axios
                    .get(config.host + "/v1/menu/" + this.today())
                    .then(response => (this.menus = response.data))
                    .catch(reason => (window.setTimeout(this.loadMenu, 5000)));
            },
            loadFood: function () {
                axios
                    .get(config.host + "/v1/order/food")
                    .then(response => (this.food = response.data))
                    .catch(reason => (window.setTimeout(this.loadFood, 5000)));
            },
            loadSoup: function () {
                axios
                    .get(config.host + "/v1/order/soup")
                    .then(response => (this.soup = response.data))
                    .catch(reason => (window.setTimeout(this.loadSoup, 5000)));
            },
            loadOrders: function() {
              axios
                  .get(config.host + "/v1/order/all/" + this.date)
                  .then(response => {
                    const codes = {}
                    response.data
                        .filter(order => order.orderedFood != null)
                        .map(order => order.orderedFood.foodCode)
                        .forEach(code => codes[code] === undefined ? codes[code] = 1 : codes[code] += 1)
                    this.orders = []
                    for (const code in codes)
                      this.orders.push({code, count: codes[code]})
                    this.orders = this.orders.sort((a, b) => b.count - a.count)
                  })
                  // eslint-disable-next-line no-unused-vars
                  .catch(reason => {
                    return (window.setTimeout(this.loadOrders, 5000));
                  });
            },
            getOrderedFood: function () {
                if (this.food === "")
                    return null;
                else
                    return this.food;
            },
            getOrderedSoup: function () {
                if (this.soup === "")
                    return null;
                else
                    return this.soup;
            },
            getMyUserId: function () {
                return localStorage.getItem("vue-user-id");
            },
            everythingLoaded: function () {
                return this.food !== null && this.menus !== null
            },
            cancelOrder: function() {
                axios
                    .delete(config.host + "/v1/order/")
                    .then(response => {
                        this.load();
                        this.snack("Objednávka na dnešek zrušena")
                    })
                    .catch(error => this.snack("Objednávku na dnešek nelze zrušit"))
            },
            today: function () {
                return new Date().toISOString().substr(0, 10);
            },
            todayHuman: function () {
                return new Date().toLocaleDateString();
            },
            orderPrice: function () { //TODO move to backend
                if(this.soup != null && this.soup.orderedSoup != null && this.soup.orderedSoup !== '') {
                    if(this.food != null && this.food !== '') {
                        if(this.food.orderedFood.priceWithSoup != null && this.food.orderedFood.priceWithSoup > 0)
                            return this.food.orderedFood.priceWithSoup;
                        else
                            return this.soup.orderedSoup.price + this.food.orderedFood.price;
                    }
                    else
                        return this.soup.orderedSoup.price;
                } else {
                    if(this.food.orderedFood != null && this.food.orderedFood !== '')
                        return this.food.orderedFood.price;
                    else
                        return 0;
                }
            },
            snack: function(message) {
                this.snackbarMessage = message;
                this.snackbarCounter++;
            },
        },
        mounted() {
            this.load();
            window.setInterval(this.load, 60000);
        }
    }
</script>

<style scoped>

</style>